export default __webpack_public_path__ + "static/media/RobKehoe.312c654c.png";